<script>
import ClubFinancialAccountingSettingsRepository from '../../js/repository/ClubFinancialAccountingSettingsRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubFinancialAccountingSettingsRepository.getDatevSettings,
                params: [this.clubId],
                callback: this.callback,
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
